import React, { Suspense, useState } from 'react';
import LazyLoad, { lazyload } from 'react-lazyload';
import { Lottie } from '@crello/react-lottie';

import Head from 'next/head';

import st from './index.module.scss';

import Pricing from '../../../components/video-production/Pricing';
import BradCrumbs from '../../../components/Base/BradCrumbs';
import Engagement from '../../../components/Engagement';
import Faq from '../../../components/Faq';
import ProcessSliderIsometric from '../../../components/sliders/ProcessSliderIsometric';
import typesLottie from '../../../public/images/types.json';
import Why from '../../../components/Why';
import ViewMore from '../../../components/ViewMore';
import BenefitsIsometric from '../../../components/video-production/explainer-videos/BenefitsIsometric';
import SolveProblemsIsometric from '../../../components/video-production/explainer-videos/SolveProblemsIsometric';

lazyload({
  width: '100%',
});

const ExplainerVideosIsometric = props => {
  const [showPricingModalF, setShowPricingModalF] = useState(false);
  const [videoLength, setVideoLength] = useState([]);
  const [script, setScript] = useState([]);

  const showPricingModal = () => {
    if (props.width < 768) {
      window.location.href = '/video-production/get-pricing';
    } else {
      setShowPricingModalF(true);
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
      window.location.hash = 'open';
    }
  };
  const hidePricingModal = () => {
    setShowPricingModalF(false);
    document.body.style.overflow = 'auto';
    document.body.style.overflowX = 'hidden';
    history.replaceState(null, null, ' ');
    document.documentElement.style.overflow = 'auto';
  };

  return (
    <>
      <Head>
        <title>Video Production - Isometric Explainer Video | Prodigi</title>
        <link rel="alternate" hrefLang="en" href="https://weprodigi.com/video-production/isometric-explainer-video" />
        <meta
          name="description"
          content="Discover the enchantment of isometric explanation videos. Animate difficult ideas into simple ones. For your upcoming project, discover their potential."
        />
        <meta property="og:url" content="https://weprodigi.com/video-production/isometric-explainer-video" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content="Video Production - Isometric Explainer Video | Prodigi" />
        <meta
          property="og:description"
          content="Discover the enchantment of isometric explanation videos. Animate difficult ideas into simple ones. For your upcoming project, discover their potential."
        />
        <meta property="og:image" content="https://weprodigi.com/uploads/images/explainer-videos/isometric-explainer/og.jpg" />
        <script
          type="application/ld+json"
          className="organization-schema"
          dangerouslySetInnerHTML={{
            __html: `{
              "@context": "http://schema.org",
              "@type": "WebPage",
              "name": "Video Production - Isometric Explainer Video | Prodigi",
              "description": "Discover the enchantment of isometric explanation videos. Animate difficult ideas into simple ones. For your upcoming project, discover their potential.",
              "url": "https://weprodigi.com/video-production/isometric-explainer-video",
              "breadcrumb": {
                "@type": "BreadcrumbList",
                "itemListElement": [
                  {
                    "@type": "ListItem",
                    "position": 1,
                    "name": "Home",
                    "item": "https://weprodigi.com"
                  },
                  {
                    "@type": "ListItem",
                    "position": 2,
                    "name": "Full Service Video Production",
                    "item": "https://weprodigi.com/video-production"
                  },
                  {
                    "@type": "ListItem",
                    "position": 3,
                    "name": "Isometric Explainer Video Production - Prodigi",
                    "item": "https://weprodigi.com/video-production/isometric-explainer-video"
                  }
                ]
              },
              "mainEntity": {
                "@type": "Product",
                "name": "Isometric Explainer Video Production",
                "description": "Discover the enchantment of isometric explanation videos. Animate difficult ideas into simple ones. For your upcoming project, discover their potential.",
                "brand": {
                  "@type": "Brand",
                  "name": "Weprodigi"
                },
                "offers": {
                  "@type": "Offer",
                  "price": "1300",
                  "priceCurrency": "USD",
                  "seller": {
                    "@type": "Organization",
                    "name": "Weprodigi"
                  }
                },
                "image": "https://weprodigi.com/images/logovertical.svg",
                "review": [
                  {
                    "@type": "Review",
                    "reviewRating": {
                      "@type": "Rating",
                      "ratingValue": "5",
                      "bestRating": "5",
                      "worstRating": "1"
                    },
                    "author": {
                      "@type": "Person",
                      "name": "Noah Davies"
                    },
                    "datePublished": "2023-02-18",
                    "reviewBody": "Outstanding work from Prodigi! Their isometric explainer video perfectly captured our brand's essence. Professional, creative, and a pleasure to work with."
                  },
                  {
                    "@type": "Review",
                    "reviewRating": {
                      "@type": "Rating",
                      "ratingValue": "5",
                      "bestRating": "5",
                      "worstRating": "1"
                    },
                    "author": {
                      "@type": "Person",
                      "name": "Arthur Schopenhauer"
                    },
                    "datePublished": "2023-12- 17",
                    "reviewBody": "Thrilled with the results from Prodigi! They created an amazing isometric explainer video that resonated with our audience. Highly recommend their services!"
                  },
                  {
                    "@type": "Review",
                    "reviewRating": {
                      "@type": "Rating",
                      "ratingValue": "4.9",
                      "bestRating": "5",
                      "worstRating": "1"
                    },
                    "author": {
                      "@type": "Person",
                      "name": "Barbara Kruger"
                    },
                    "datePublished": "2024-03-13",
                    "reviewBody": "Prodigi's isometric explainer videos are pure magic! They transformed our vision into a visually stunning masterpiece. Couldn't be happier with the result!."
                  }
                ],
                "aggregateRating": {
                  "@type": "AggregateRating",
                  "ratingValue": "4.9",
                  "reviewCount": "3"
                }
              }
            }            
            `,
          }}
        />
      </Head>

      {/*    Header video */}
      <div className={`relative w-full  h-intro  overflow-hidden  `}>
        <video
          width="100%"
          height="100%"
          autoPlay
          loop
          muted
          playsInline
          preload="none"
          id="header-11"
          className={'absolute h-intro md:h-full ' + st['header-mp4']}
        >
          <source src="https://weprodigi.com/uploads/images/explainer-videos/isometric-explainer/isometric-explainer.mp4" type="video/mp4" />
        </video>
        <div className={st['overlay']}></div>
        <div className="container h-full">
          <div className="relative h-full  flex flex-col flex-wrap justify-center items-start overflow-hidden">
            <h1 className="max-w-300 md:max-w-600 uppercase md:normal-case text-white text-30 md:text-72 font-black md:font-bold leading-tight">
              Isometric Explainer Video Production
            </h1>
            <a
              onClick={showPricingModal}
              className="relative flex items-center justify-center min-w-250 z-10 border-2 rounded-5 border-green-badge hover:border-green-hover text-18 text-white px-23 mt-48 md:mt-23 py-8 bg-green-badge hover:bg-green-hover hover:text-white transition-all   transition-400 cursor-pointer"
            >
              Get Pricing
              <img src="https://weprodigi.com/uploads/images/explainer-videos/buttonIcon.svg" className={'ml-10'} alt="pricing icon" />
            </a>
          </div>
        </div>
      </div>

      <div className="bg-white">
        <div className="container">
          <BradCrumbs
            items={[
              {
                url: '/video-production',
                name: 'Video Production',
              },
              {
                url: '/video-production/explainer-videos',
                name: 'Explainer Video Production',
              },
              {
                url: '/video-production/isometric-explainer-video',
                name: 'Isometric Explainer Video',
              },
            ]}
          />
          <div className="relative pt-20 md:pt-0 pb-48">
            <div className="flex flex-wrap md:flex-nowrap justify-between">
              <LazyLoad className="mr-auto mt-24 md:mt-0 max-w-270 w-full md:w-auto" height={200} once>
                <Lottie
                  config={{
                    animationData: typesLottie,
                    loop: true,
                    autoPlay: true,
                  }}
                  playingState="playing"
                />
              </LazyLoad>
              <div className="flex flex-col ml-12 items-center justify-center max-w-756">
                <Engagement title="Video">
                  An isometric explainer video is a mix of bright graphics and stories, turning clumsy ideas into eye-candy tales. How? Why? The
                  answers emerge with each scroll!
                </Engagement>
              </div>
            </div>
          </div>
        </div>
      </div>

      <LazyLoad height={200} once>
        <div className={'bg-gray-white py-24'}>
          <div className="container">
            <h2 className={'w-full lg:w-half-auto font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
              What is an Isometric Explainer Video?
            </h2>

            <div className={'block md:flex justify-between flex-row md:flex-row-reverse'}>
              <div className=" pl-0 md:pl-20 pb-10 w-full md:w-half-auto block  mt-23 mb-10">
                <LazyLoad height={315} offset={100}>
                  <iframe
                    width="560"
                    height="315"
                    className="w-full"
                    src="https://www.youtube.com/embed/_-wiEA5mE5c?controls=0"
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </LazyLoad>
                <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>
                  APEC Network | Software Solution Isometric Explainer
                </p>
              </div>

              <p className={'mt-20 w-half-auto hidden md:block'}>
                Imagine looking at your screen unfolds a colorful world before you. You soon feel yourself as a part of a vibrant movement. 3D
                products, characters, and details pop up on your screen, leaving an impression of depth and vitality. Yet, in reality, everything is
                flat․ That’s the magic of an isometric animation. This style makes complex ideas easy and fun. It works wonders across any field.
              </p>
              <div className={'mt-20 block md:hidden'}>
                <ViewMore ln={40}>
                  Imagine looking at your screen unfolds a colorful world before you. You soon feel yourself as a part of a vibrant movement. 3D
                  products, characters, and details pop up on your screen, leaving an impression of depth and vitality. Yet, in reality, everything is
                  flat․ That’s the magic of an isometric animation. This style makes complex ideas easy and fun. It works wonders across any field.
                </ViewMore>
              </div>
            </div>
            <br className={'clear-both hidden'} />
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className={'bg-white py-24'}>
          <div className="container">
            <h2 className={'w-full md:w-75p font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
              Where to Use Isometric Explainer Videos?
            </h2>
            <p className={'mt-20'}>
              Ever wondered how to send engaging messages to your audience? Isometric explainer videos can be your long-awaited solution. Mixing
              vibrant 2D and 3D details, they shine on any digital platform. Discover their power in your industry!
            </p>

            <div className="flex flex-wrap-reverse md:flex-nowrap justify-between items-start mt-0 md:mt-24">
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <LazyLoad height={315} offset={100}>
                  <iframe
                    width="560"
                    height="315"
                    className="w-full"
                    src="https://www.youtube.com/embed/bZGxmxo1ZYM?controls=0"
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </LazyLoad>
                <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>Aliz | Software Solution Isometric Explainer</p>
              </div>

              <div className={'w-full md:w-half-auto mt-24 md:mt-0'}>
                <h3 className="text-purple font-bold text-24   leading-none">Marketing and Advertising</h3>
                <div className={'mt-16 hidden md:block'}>
                  Isometric explainer videos offer a great marketing and advertising tool. The 3D-like style enhances the interactivity of the viewer
                  through the platforms. They are used for vivid product demonstrations that strive to increase sales. Besides, they work wonders to
                  raise website traffic. With their flexible and attractive nature, these videos serve as dynamic tools for capturing audience
                  interest.
                </div>
                <div className={'mt-16 block md:hidden'}>
                  <ViewMore ln={40}>
                    Isometric explainer videos offer a great marketing and advertising tool. The 3D-like style enhances the interactivity of the
                    viewer through the platforms. They are used for vivid product demonstrations that strive to increase sales. Besides, they work
                    wonders to raise website traffic. With their flexible and attractive nature, these videos serve as dynamic tools for capturing
                    audience interest.
                  </ViewMore>
                </div>
              </div>
            </div>

            <div className="flex flex-wrap md:flex-nowrap justify-between mt-0 md:mt-48">
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <h3 className="text-purple font-bold text-24 leading-none">Education and Training</h3>
                <p className={'mt-16'}></p>

                <p className={'mt-16 hidden md:block'}>
                  Searching for an influential tool for education and training? Explore isometric video benefits! With fun, 3D-style isometric
                  graphics, they make complex ideas simple and available. And what does this simplicity yield? It allows learners to understand and
                  recall ideas more effectively. They keep students interested and eager to learn, whether in the classroom, online courses, or
                  e-learning platforms.
                </p>
                <div className={'mt-16 block md:hidden'}>
                  <ViewMore ln={40}>
                    Searching for an influential tool for education and training? Explore isometric video benefits! With fun, 3D-style isometric
                    graphics, they make complex ideas simple and available. And what does this simplicity yield? It allows learners to understand and
                    recall ideas more effectively. They keep students interested and eager to learn, whether in the classroom, online courses, or
                    e-learning platforms.
                  </ViewMore>
                </div>
              </div>
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <LazyLoad height={315} offset={100}>
                  <iframe
                    width="560"
                    height="315"
                    className="w-full"
                    src="https://www.youtube.com/embed/HuzCGZ15ZBE?controls=0"
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </LazyLoad>
                <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>Secro | Isometric Exmplainer Video</p>
              </div>
            </div>
            <div className="flex flex-wrap-reverse md:flex-nowrap justify-between mt-24 md:mt-48">
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <LazyLoad height={315} offset={100}>
                  <iframe
                    width="560"
                    height="315"
                    className="w-full"
                    src="https://www.youtube.com/embed/GGcN1lJNvj0?controls=0"
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </LazyLoad>
                <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>Data Monkeys | Isometric Explainer Video</p>
              </div>

              <div className={'w-full md:w-half-auto '}>
                <h3 className="text-purple font-bold text-24 leading-none">SaaS and Technology</h3>
                <p className={'mt-16 hidden md:block'}>
                  The power of isometric animation visualizes your SaaS or technology product. Vibrant 3D-like isometric motion graphics guarantee
                  that even the most complex ideas become entertaining and catchy․ This method helps to show the user the functionality and technical
                  details of the product. It's that simple! "The more users understand your product's value, the more likely they are to use it.
                </p>
                <div className={'mt-16 block md:hidden'}>
                  <ViewMore ln={'40'}>
                    The power of isometric animation visualizes your SaaS or technology product. Vibrant 3D-like isometric motion graphics guarantee
                    that even the most complex ideas become entertaining and catchy․ This method helps to show the user the functionality and
                    technical details of the product. It's that simple! "The more users understand your product's value, the more likely they are to
                    use it.
                  </ViewMore>
                </div>
              </div>
            </div>
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className={'bg-gray-light py-24'}>
          <div className="container">
            <h2 className={'w-full font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
              {' '}
              Benefits of Isometric Explainer Videos
            </h2>
            <p className={'mt-20'}>
              Looking for an effective way to communicate with your audience? Discover how an animated isometric video can be a game changer for you.
            </p>
            <Suspense fallback={`Loading...`}>
              <BenefitsIsometric />
            </Suspense>
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className="bg-white">
          <div className="container py-23">
            <h2 className="text-purple text-24 md:text-36 text-left mb-23 font-black uppercase leading-none">
              Our Isometric Explainer Video Animation Process
            </h2>
            <ProcessSliderIsometric />
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={0} once>
        <div className={'h-500 md:h-310 overflow-hidden relative ' + st['bg-contact']}>
          <div id="stars" />
          <div id="stars2" />
          <div id="stars3" />
          <div className="container flex flex-wrap md:flex-nowrap justify-between items-end md:items-center h-full ">
            <div
              className={
                'mt-24 md:mt-0 text-left md:text-center font-bold uppercase  text-white leading-28 md:leading-44   text-20 md:text-26 lg:text-36'
              }
            >
              CALCULATE YOUR ISOMETRIC EXPLAINER VIDEO PRICE
              <br />
              <span className={'pt-20 font-normal normal-case text-18 md:text-24 leading-20 md:leading-29 '}>
                Answer five questions and get to know the price!
              </span>
              <div className={'flex justify-end md:justify-center mt-0 leading-0'}>
                <button
                  onClick={showPricingModal}
                  className="uppercase h-40 text-18 leading-24  hover:bg-green-hover md:flex justify-center items-center   w-auto mt-24 text-white bg-green rounded-5 px-23 py-0 md:py-5"
                >
                  Start Now
                </button>
              </div>
            </div>
            <img src="https://weprodigi.com/uploads/images/explainer-videos/Inga.webp" alt="eva" className={st['inga']} />
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className={'bg-white py-24'}>
          <div className="container">
            <h2 className={'w-full font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
              How Isometric Explainer Video Can Help Your Business?
            </h2>
            <p className={'mt-20'}>
              Isometric explainer videos are eye-catching with their 3D-like depth and realism. But that's not all you need to know. They are also
              effective as business tools. Scroll down to know how!
            </p>
            <Suspense fallback={`Loading...`}>
              <SolveProblemsIsometric />
            </Suspense>
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className="bg-gray-light">
          <div className="container py-23">
            <h2 className="uppercase text-30 md:text-36 mb-23 font-black text-purple leading-none">
              Why Choose Us for Your Isometric Explainer Video Production?
            </h2>
            <Why
              content={[
                {
                  title: 'We use state-of-the-art technologies',
                  answer:
                    'Production process in our isometric explainer video company incorporates the latest tools and solutions known to the world of animation.',
                },
                {
                  title: 'We create compelling stories',
                  answer: "Our animations don't just engage the viewer. They are vividly imprinted in the memory, causing a long-lasting impact.",
                },
                {
                  title: 'We handle everything',
                  answer:
                    "Our dedicated professionals are at your side throughout the isometric explainer video production process. Whether it's strategic planning, idea development, or video optimization, you'll get only top-notch isometric explainer video services.",
                },
                {
                  title: 'We don’t require prepayment',
                  answer:
                    'We picked the milestone payment method for our isometric explainer video services, as we believe that it is the optimal option for both us and our clients. ',
                },
              ]}
            />
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className="bg-white">
          <div className="container py-23">
            <h2 className="uppercase text-24 md:text-36 mb-23 font-black text-purple leading-none">FAQ</h2>
            <div className="grid md:grid-cols-2 md:gap-30">
              <Faq
                content={[
                  {
                    title: 'What style of animation is used in explainer videos? ',
                    answer:
                      '2D/3D, whiteboard, motion graphics, isometric animations are often used for explainer videos. The choice of style depends on ideas, goals, platforms, etc.',
                  },
                  {
                    title: 'What makes an isometric explainer video a good one?',
                    answer:
                      'The ability to show depth and dimension is the main strength of these videos. The isometric perspective enhances the visual appeal and allows you to present ideas in a clear and detailed way.',
                  },
                ]}
              />
              <Faq
                content={[
                  {
                    title: 'Can isometric videos be used for any industry or topic?',
                    answer:
                      "Short answer: Yes! Isometric videos are versatile and work great for any industry or topic. They help explain ideas clearly, whether it's in marketing, technology, finance, education, healthcare, or anything else.",
                  },
                  {
                    title: 'How does an isometric explainer video differ from other types of explainer videos? ',
                    answer:
                      'An isometric explainer video uses a special perspective that makes things look 3D. This not only attracts attention, but also makes the scenes clear and detailed.',
                  },
                ]}
              />
            </div>
          </div>
        </div>
      </LazyLoad>

      <Pricing videoLength={videoLength} script={script} country={props.country} show={showPricingModalF} hide={hidePricingModal} step={1} />
    </>
  );
};

export default ExplainerVideosIsometric;
